module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a1-2-66c20cda90c066b396d79eb465911682.jpg";